var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolutne w-screen h-screen",attrs:{"id":"3d_logo"}})}
var staticRenderFns = []

export { render, staticRenderFns }